module.exports = __webpack_public_path__ + "img/1 (111).000bde01.png";